import './SizesTable.css';
import tallesImg from './talles.jpg';

function SizesTable() {
    return (
        <div className="container">
            <img className="image" src={tallesImg} alt="Talles" />
        </div>
  );
}

export default SizesTable;